module.exports = __webpack_public_path__ + "img/flow_gray.b3d9a150.svg";